/* eslint-disable consistent-return */
import styled, { CSSObject } from '@emotion/styled';
import { rgba } from 'polished';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { getBicycleColor, getTextColor } from '@/utility/theme/bicycleColor';

const tdBaseCss = {
  height: '50px',
  fontSize: defaultTheme.font.size.s,
  verticalAlign: 'middle',
  textAlign: 'center',
  border: `solid ${defaultTheme.border.color.black}`,
  borderWidth: '1px 1px 0 0',
};

export const Container = styled.div(() =>
  mq({
    position: 'relative',
    width: '100%',
  }),
);

export const ScrollWrapper = styled.div((props: { scrollable?: boolean }) =>
  mq({
    width: '100%',
    overflowX: props.scrollable ? 'auto' : 'inherit',
  }),
);

export const Table = styled.table(() =>
  mq({
    width: '100%',
    border: 'solid #323332',
    borderWidth: '1px 0',
    fontSize: '11px',
    tableLayout: 'fixed',
  }),
);

export const TableRow = styled.tr(
  (props: { bicycleNum: number; disabled: boolean }) =>
    mq({
      '& > td': {
        backgroundColor: props.disabled
          ? `${defaultTheme.background.darkGray}`
          : rgba(getBicycleColor(props.bicycleNum), 0.1),
        opacity: props.disabled && defaultTheme.button.opacity.disabled,
      },
    }),
);

// th
export const BorderHeader = styled.th(
  (props: {
    isBorderRightNone?: boolean;
    isBorderLeftNone?: boolean;
    width?: CSSObject['width'];
    textAlign?: CSSObject['textAlign'];
  }) =>
    mq({
      width: props.width,
      height: '30px',
      fontSize: defaultTheme.font.size.xs,
      fontWeight: 'inherit',
      lineHeight: defaultTheme.font.height.base,
      backgroundColor: defaultTheme.background.mediumGray,
      verticalAlign: 'middle',
      textAlign: props.textAlign || 'center',
      borderRight: props.isBorderRightNone
        ? 'none'
        : `1px solid ${defaultTheme.border.color.black}`,
      borderLeft: props.isBorderLeftNone ? 'none' : '',
      padding: `0 ${defaultTheme.spacing.xs}`,
      whiteSpace: 'nowrap',
    }),
);

export const RacerNameHeader = styled(BorderHeader)(
  (props: { width?: CSSObject['width']; isNone?: boolean }) =>
    mq({
      textAlign: 'left',
      padding: `0 ${defaultTheme.spacing.s}`,
      width:
        props.width ||
        (props.isNone ? ['145px', 'auto', 'auto', 'auto'] : '145px'),
    }),
);

export const WinningAvarageHeader = styled(BorderHeader)(() =>
  mq({
    textAlign: 'left',
    padding: `0 ${defaultTheme.spacing.s}`,
    width: '200px',
  }),
);

// td
export const BorderData = styled.td(
  (props: { isBorderRightNone?: boolean; isBorderLeftNone?: boolean }) =>
    mq({
      ...tdBaseCss,
      borderRight: props.isBorderRightNone ? 'none' : '',
      borderLeft: props.isBorderLeftNone ? 'none' : '',
    }),
);

export const BicycleNumberData = styled.td(
  (props: { bicycleNum: number; disabled: boolean }) =>
    mq({
      ...tdBaseCss,
      color: props.disabled
        ? defaultTheme.background.mediumGray
        : getTextColor(props.bicycleNum),
      fontWeight: 'bold',
      backgroundColor: props.disabled
        ? defaultTheme.background.darkGray
        : `${getBicycleColor(props.bicycleNum)} !important`,
      opacity: '1 !important',
      fontFamily: defaultTheme.font.family.bicycleNumber,
    }),
);

// 着順 欠車の場合でもグレーアウトしない
export const ArrivalOrderData = styled.td(
  (props: { arrivalOrder: number | undefined }) =>
    mq({
      ...tdBaseCss,
      borderLeft: 'none',
      backgroundColor: `${defaultTheme.background.white} !important`,
      fontWeight:
        props.arrivalOrder && props.arrivalOrder >= 1 && props.arrivalOrder <= 3
          ? 'bold'
          : 'normal',
      fontFamily: defaultTheme.font.family.bicycleNumber,
      opacity: '1 !important',
    }),
);

export const GearRatioBefore = styled.span(() =>
  mq({
    display: 'block',
    fontSize: defaultTheme.font.size.xs,
    textDecoration: 'line-through',
    marginBottom: defaultTheme.spacing.xs,
  }),
);

export const MarkSymbol = styled.div((props: { path: string }) =>
  mq({
    width: '14px',
    height: '14px',
    backgroundImage: `url(${props.path})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    margin: '0 auto',
  }),
);
